import React from 'react';
import { Link,Redirect } from 'react-router-dom';

const NotFound = () => {
  return(
    <Redirect to='/' />
  )
}

export default NotFound;